<div class="data-filter">
    <label [i18n]="[{target: 'innerHTML', key: labelKey}]"></label>
    <div class="data-filter-switch">
        <app-switcher [(ngModel)]="model" (change)="change()"></app-switcher>
    </div>
</div>
